import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { destroy } from 'redux-form';
import DashboardMaintenanceEnquiry from './DashboardMaintenanceEnquiry';
import DashboardMaintenanceEnquiryProvider from './DashboardMaintenanceEnquiry.context';
import { selectors as uiSelectors, actions as uiActions } from 'ducks/ui';
import { IDashboardMaintenanceEnquiryProps } from './DashboardMaintenanceEnquiry.properties';
import { selectors as dashboardMaintenanceSelectors, actions as dashboardMaintenanceActions } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { FORM_NAME } from './DashboardDetails/DashboardDetails.container';

const mapStateToProps = (state) => {
    const params = new URLSearchParams(location.search);

    return ({
        selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
        selectedDashboardType: dashboardMaintenanceSelectors.selected(state)?.DashboardType,
        isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
        isDashboardMaintenanceEnquiryLookUpOpen: uiSelectors.isDashboardMaintenanceEnquiryLookUpOpen(state),
    });
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        toggleMenuOption: uiActions.toggleMenuOption,
        searchById: dashboardMaintenanceActions.searchById,
        resetSearchLookupDrawer: dashboardMaintenanceActions.reset,
        destoryForm: () => destroy(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((props: Readonly<
    IDashboardMaintenanceEnquiryProps>) => {
    return (
        <DashboardMaintenanceEnquiryProvider>
            <DashboardMaintenanceEnquiry {...props} />
        </DashboardMaintenanceEnquiryProvider>
    );
});
